import React, { useLayoutEffect, useRef, useState } from "react";

// mw authors/validates AI html at canvas px (1920 logical); the stage is laid
// out at screen px (not transform-scaled), so a 100% iframe sees a smaller
// viewport. Render children in a wrapper of canvas-px size scaled to the box.
export const CANVAS_LOGICAL_WIDTH = 1920;

export default function ScaledCanvasFrame({ children }) {
  const outerRef = useRef(null);
  const [fit, setFit] = useState(null);

  useLayoutEffect(() => {
    const outer = outerRef.current;
    const stage = outer && outer.closest(".slide_air");
    if (!stage) return undefined;
    const measure = () => {
      const scale = stage.offsetWidth / CANVAS_LOGICAL_WIDTH;
      if (!scale || !outer.offsetWidth) return;
      setFit((prev) => {
        const next = {
          scale,
          width: outer.offsetWidth / scale,
          height: outer.offsetHeight / scale,
        };
        return prev &&
          prev.scale === scale &&
          prev.width === next.width &&
          prev.height === next.height
          ? prev
          : next;
      });
    };
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(measure);
    ro.observe(stage);
    ro.observe(outer);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={outerRef}
      style={{ position: "relative", width: "100%", height: "100%", overflow: "hidden" }}
    >
      <div
        style={
          fit
            ? {
                position: "absolute",
                top: 0,
                left: 0,
                width: fit.width + "px",
                height: fit.height + "px",
                transform: `scale(${fit.scale})`,
                transformOrigin: "0 0",
              }
            : { position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }
        }
      >
        {children}
      </div>
    </div>
  );
}
